import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import mine from '@/components/mine'
import orderList from '@/components/order/list'
import orderDetails from '@/components/order/details'
import exchange from '@/components/exchange'
import integral from '@/components/integral'
import balance from '@/components/balance'
import record from '@/components/record'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mine',
      component: mine
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },
    {
      path: '/balance',
      name: 'balance',
      component: balance,
      meta: { title: '余额记录' }
    },
    {
      path: '/integral',
      name: 'integral',
      component: integral,
      meta: { title: '积分记录' }
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: exchange,
      meta: { title: '兑换记录' }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: { title: '订单记录' }
    },
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: orderDetails,
      meta: { title: '订单详情' }
    },
    {
      path: '/record',
      name: 'record',
      component: record,
      meta: { title: '数据看板' }
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js